import { render, staticRenderFns } from "./ClientsDetail.vue?vue&type=template&id=ceab6544&scoped=true&"
import script from "./ClientsDetail.vue?vue&type=script&lang=js&"
export * from "./ClientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDetail.vue?vue&type=style&index=0&id=ceab6544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceab6544",
  null
  
)

export default component.exports